import { ReactNode } from 'react';

interface CardProps {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  /** パディングなし（内部で独自のパディングを適用する場合） */
  noPadding?: boolean;
}

export default function Card({ title, subtitle, actions, children, className = '', noPadding = false }: CardProps) {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 ${className}`}>
      {(title || actions) && (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 px-4 py-3 lg:px-6 lg:py-4 border-b dark:border-gray-700">
          <div className="min-w-0">
            {title && <h3 className="text-base lg:text-lg font-semibold text-gray-900 dark:text-white truncate">{title}</h3>}
            {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
        </div>
      )}
      <div className={noPadding ? '' : 'p-4 lg:p-6'}>{children}</div>
    </div>
  );
}
